import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import type { FundingApplicationSchemas } from "api-types";
import { useLocation } from "react-router";

import { AIR_RECONNECT_CONNECTION_UPDATE_API, FUNDING_APPLICATION_REVIEW_STATUS_API } from "../../components/constants";
import { handleCompletedCustomerTaskForSession } from "../../utils/completed-customer-task-for-session";

export const useAirReconnectConnectionMutation = (customerDomain: string) => {
  const client = useAxios();
  const queryClient = useQueryClient();
  const { pathname } = useLocation();
  const mutationUrl = AIR_RECONNECT_CONNECTION_UPDATE_API.replace(":customerSlug", customerDomain);
  return useMutation({
    mutationFn: (data: FundingApplicationSchemas.AIRReconnectConnectionUpdateParams) => {
      return client.post(mutationUrl, data);
    },
    onSuccess: (_, data: FundingApplicationSchemas.AIRReconnectConnectionUpdateParams) => {
      queryClient.invalidateQueries({
        queryKey: [FUNDING_APPLICATION_REVIEW_STATUS_API.replace(":customerSlug", customerDomain)],
      });
      handleCompletedCustomerTaskForSession(data.airPublicId, pathname);
    },
  });
};
